export default __webpack_public_path__ + "static/media/ipX5.24153200.svg";